import {request} from './request'

// 首页数据-导出
export function getHomeAllData(){
    return request({
        // 配置参数--url
        url:'/api/index'
    })
}

export function getHomeGoods(type='sales',page=1){
    return request({
        // 配置参数--url
        url:'/api/index?'+type+'=1&page='+page,
    })
}
